// @flow

import I18n from '@insolus/i18n';
import Config from '@insolus/config';
import resources from '../../locales';

export default () => {
    const serverI18n = Config.get('serverContext.i18n', {});

    I18n.init({
        lang      : serverI18n.lang,
        whitelist : [...Config.get('language.list')],
        default   : Config.get('language.default'),
        cookie    : serverI18n.cookie || 'lang',
        resources
    });
};
